import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule, WfAvatarComponent } from 'wflow-ui';
import { PEPPOL_STATUS_CONFIG } from '../../const/peppol-status.const';
import { PeppolDetailEvent } from '../../interfaces/peppol-detail.interface';
import { PeppolItemStatus } from '../../interfaces/peppol-item.interface';

@Component({
  selector: 'wf-peppol-status-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe, TranslateModule, IconsModule, WfAvatarComponent],
  templateUrl: './peppol-status-card.component.html',
  styleUrl: './peppol-status-card.component.scss',
  host: { class: 'wf-peppol-status-card' },
})
export class PeppolStatusCardComponent {
  readonly event = input.required<PeppolDetailEvent>();

  protected readonly config = computed(
    () => PEPPOL_STATUS_CONFIG[this.event().status],
  );

  protected readonly isRejected = computed(
    () => this.event().status === PeppolItemStatus.RE,
  );
}
